export default __webpack_public_path__ + "static/media/686.b05cc135.png";